import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  FormControl,
  TextField,
  MenuItem,
  InputLabel,
  Select,
  InputAdornment,
  Skeleton,
  Tooltip,
  IconButton,
} from "@mui/material";
import { tableCellLab, tableRowLab } from "../../style/LapPageStyle";
import "react-toastify/dist/ReactToastify.css";
import CustomModal from "../CustomModal/CustomModal";
import UseFetchCollections from "../../helper/UseFetchCollections";
import PastBillPharmacyByInvoice from "../ModalChildren/PastBillPharmacyByInvoice";
import Loader from "../UI/Loader";
import not_found from "../../assets/not_found.svg";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import dayjs from "dayjs";
import useDebounce from "../../hooks/UseDebounce";
import SearchIcon from "@mui/icons-material/Search";
import { ClearIcon } from "@mui/x-date-pickers";
import RefreshIcon from "@mui/icons-material/Refresh";

const RefundInvoices = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [startDate, setStartDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [searchValue, setSearchValue] = useState("");
  const [openBillByInvoice, setOpenBillByInvoice] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedInvoiceUid, setSelectedInvoiceUid] = useState(null);

  const debounceValue = useDebounce(searchValue, 500);

  useEffect(() => {
    setPage(1); // reset page whenever searchValue changes
  }, [debounceValue]);

  //get collection data
  const {
    data: collectionArray,
    refetch,
    isLoading,
  } = UseFetchCollections(
    startDate,
    "cancelled,returned",
    endDate,
    page,
    itemPerPage,
    debounceValue,
  );

  useEffect(() => {
    if (startDate && endDate) {
      refetch();
    }
    if (collectionArray) {
      setTotal(collectionArray?.meta?.total_collection || 0);
    }
  }, [startDate, endDate, itemPerPage, page]);

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const totalRecords = collectionArray?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  // Handle date change
  // const handleDateChange = (event) => {
  //     setTotal(0);
  //     setSelectedDate(event.target.value);
  // };

  // const handleOpenBillByInvoice = (id) => {
  //     setSelectedInvoiceId(id);
  //     setOpenBillByInvoice(true);
  // setTimeout(() => {
  //   onClose();
  // }, 100);
  // };

  const handleOpenBillByInvoiceClose = () => setOpenBillByInvoice(false);

  useEffect(() => {
    if (collectionArray?.payload?.invoices) {
      const grandTotalSum = collectionArray.payload.invoices.reduce(
        (acc, invoice) => {
          return (
            acc +
            (invoice.grand_total < 0
              ? Math.abs(invoice.grand_total)
              : invoice.grand_total || 0)
          );
        },
        0,
      );
      setTotal(grandTotalSum);
    }
  }, [collectionArray]);

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    refetch(); // optional: immediately fetch data without date filter
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "65vh",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        sx={{ flexWrap: "wrap", gap: 2 }}
      >
        {/* <FormControl variant="outlined" sx={{ width: "160px" }}>
                    <TextField
                        defaultValue={new Date().toISOString().split("T")[0]}
                        max={new Date().toISOString().split("T")[0]}
                        type="date"
                        sx={{
                            marginTop: "2px",
                            "& .MuiOutlinedInput-root": {
                                height: "40px",
                                borderRadius: '15px',
                                fontSize: "14px",
                                "& input": {
                                    padding: "8px",
                                    fontSize: "14px",
                                },
                                fontWeight: '600',
                                backgroundColor: "#F7F7FF",
                                transition: "background-color 0.3s",
                            },
                            "& fieldset": {
                                border: "none", // Removes the default border
                            },
                            "& .MuiInputBase-root": {
                                backgroundColor: "#F7F7FF",
                                transition: "background-color 0.3s",
                            }, cursor: 'pointer',

                        }}
                        value={selectedDate}
                        onChange={handleDateChange}
                        name="Date"
                    />
                </FormControl> */}
        <Box sx={{ gap: 2, display: "flex", flexWrap: "wrap" }}>
          {/* Start Date */}
          <FormControl variant="outlined" sx={{ width: "160px" }}>
            <TextField
              type="date"
              label="Start Date"
              value={startDate}
              onChange={handleStartDateChange}
              inputProps={{ max: endDate }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "40px",
                  borderRadius: "15px",
                  fontSize: "14px",
                  backgroundColor: "#F7F7FF",
                  fontWeight: "600",
                },
                "& fieldset": { border: "none" },
                cursor: "pointer",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>

          {/* End Date */}
          <FormControl variant="outlined" sx={{ width: "160px" }}>
            <TextField
              type="date"
              label="End Date"
              value={endDate}
              onChange={handleEndDateChange}
              inputProps={{
                min: startDate,
                max: new Date().toISOString().split("T")[0],
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "40px",
                  borderRadius: "15px",
                  fontSize: "14px",
                  backgroundColor: "#F7F7FF",
                  fontWeight: "600",
                },
                "& fieldset": { border: "none" },
                cursor: "pointer",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>

          {/* Clear Dates Button with Tooltip */}
          <Tooltip title="Clear Dates">
            <RefreshIcon
              sx={{
                color: "#e11616ff",
                fontSize: 20,
                height: 33,
                width: 34,
                borderRadius: "16px",
                marginLeft: "-10px",
                "&:hover": { color: "#b44e4eff" },
                cursor: "pointer",
                marginTop: "2px",
              }}
              onClick={handleClearDates}
            />
            {/* </IconButton> */}
          </Tooltip>

          <FormControl
            variant="outlined"
            sx={{ width: "160px", marginLeft: "10px" }}
          >
            <TextField
              // label="Search by Name and Invoice id"
              placeholder="Search by Name / Invoice ID"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "gray", fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                minWidth: 250,
                "& .MuiOutlinedInput-root": {
                  height: "40px",
                  borderRadius: "15px",
                  fontSize: "14px",
                  backgroundColor: "#F7F7FF",
                  fontWeight: "400",
                },
                "& fieldset": { border: "none" },
                cursor: "pointer",
              }}
            />
          </FormControl>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={"bold"} variant="h6" mb={2}></Typography>

          <Typography
            fontWeight={"600"}
            mb={2}
            sx={{
              backgroundColor: "#F7F7FF",
              padding: "10px",
              borderRadius: "12px",
            }}
          >
            <Typography fontSize={"16px"} variant="span">
              {" "}
              Refunds{" "}
            </Typography>{" "}
            &#8377;
            {collectionArray?.meta?.total_collection
              ? collectionArray.meta.total_collection.toFixed(2)
              : "0.00"}
          </Typography>
        </Box>
      </Box>

      <Grid container sm={12} md={12} marginBottom={"auto"} lg={12}>
        <Grid item xs={12}>
          <TableContainer
            sx={{
              mt: 2,
              width: "100%",
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none",
            }}
          >
            <Table
              sx={{
                width: "100%",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
                },
                "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
                "scrollbar-width": "none",
              }}
            >
              <TableHead stickyHeader>
                <TableRow sx={{ textAlign: "center" }}>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      textAlign: "center",
                    }}
                  >
                    Sr No.
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      textAlign: "center",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      textAlign: "center",
                    }}
                  >
                    Patient ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      textAlign: "center",
                    }}
                  >
                    Invoice Id
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      textAlign: "center",
                    }}
                  >
                    Amount
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      borderTopRightRadius: "20px",
                      borderBottomRightRadius: "20px",
                      textAlign: "center",
                    }}
                  >
                    Generated at
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      p: "6px",
                      textAlign: "center",
                    }}
                  >
                    Status / Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {isLoading
                  ? // Show 5 skeleton rows while loading
                    Array.from(new Array(5)).map((_, index) => (
                      <TableRow key={index}>
                        {[...Array(7)].map((_, i) => (
                          <TableCell key={i}>
                            <Skeleton variant="rectangular" height={18} />
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  : collectionArray?.payload?.invoices?.map(
                      (invoice, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            ...tableRowLab,
                            borderBottom: "8px solid white",
                            borderTop: index === 0 ? "2px solid white" : " ",
                            "&:hover": {
                              transform: "scale(1.001)",
                              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                              borderRadius: "20px !important",
                            },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...tableCellLab,
                              paddingY: "8px",
                              borderTopLeftRadius: "20px",
                              borderBottomLeftRadius: "20px",
                            }}
                          >
                            <Typography
                              variant="body_Grey1"
                              // color={
                              //     invoice?.grand_total < 0
                              //         ? "neutral.textDanger"
                              //         : "text.black"
                              // }
                            >
                              {index + 1}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              // color={
                              //     invoice?.grand_total < 0
                              //         ? "neutral.textDanger"
                              //         : "text.black"
                              // }
                              variant="heading2"
                            >
                              {" "}
                              {invoice.name}
                            </Typography>
                            {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <MobileScreenShareRoundedIcon sx={{ height: "12px", width: "12px" }} />
                <Typography variant="body2_text">
                  {" "}
                  {"1234567890"}
                </Typography>
              </Box> */}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              // color={
                              //     invoice?.grand_total < 0
                              //         ? "neutral.textDanger"
                              //         : "text.black"
                              // }
                              variant="body_Grey1"
                            >
                              {invoice?.patient_uid
                                ? invoice?.patient_uid
                                : "-"}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              // color={
                              //     invoice?.grand_total < 0
                              //         ? "neutral.textDanger"
                              //         : "text.black"
                              // }
                              variant="body_Grey1"
                            >
                              {invoice?.uid}
                              {invoice?.old_uid ? ` (${invoice.old_uid})` : ""}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              // color ={
                              //     invoice?.grand_total < 0
                              //         ? "neutral.textDanger"
                              //         : "text.black"
                              // }
                              variant="body_Grey1"
                            >
                              {" "}
                              {invoice.grand_total < 0
                                ? invoice.grand_total
                                : -invoice.grand_total}
                            </Typography>
                          </TableCell>

                          <TableCell
                            sx={{
                              ...tableCellLab,
                              // borderTopRightRadius: '20px',
                              // borderBottomRightRadius: '20px',
                            }}
                          >
                            <Typography
                              // color={
                              //     invoice?.grand_total < 0
                              //         ? "neutral.textDanger"
                              //         : "text.black"
                              // }
                              variant="body_Grey1"
                            >
                              {dayjs(
                                invoice?.generated_at,
                                "YYYY-MM-DD hh:mm A",
                              ).format("MMMM DD YYYY, hh:mm A")}{" "}
                            </Typography>
                          </TableCell>

                          <TableCell
                            sx={{
                              ...tableCellLab,
                              borderTopRightRadius: "20px",
                              borderBottomRightRadius: "20px",
                            }}
                          >
                            <Box
                              sx={{
                                flexDirection: "row",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                color={
                                  invoice?.status === "cancelled"
                                    ? "neutral.textDanger"
                                    : "#FF8D1E"
                                }
                                fontSize={"16px"}
                                variant="heading2"
                              >
                                {invoice?.status}
                              </Typography>

                              {/* {invoice?.status !== 'cancelled' && <Button
                                                        sx={{
                                                            ...primaryBtnTeal,
                                                            color: 'white',
                                                            paddingY: "2px",
                                                            paddingX: "20px",
                                                            fontSize: '15px',
                                                            width: 'min-content'
                                                        }}
                                                        onClick={() => {
                                                            handleOpenBillByInvoice(invoice?.id);
                                                            setSelectedInvoiceUid(invoice?.uid);
                                                        }}
                                                    >
                                                        {selectedDate !== new Date().toISOString().split("T")[0] ? "View" : "Modify"}
                                                    </Button>} */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
              </TableBody>
            </Table>

            {!isLoading && !collectionArray?.payload?.invoices?.length && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  width: "30%",
                  margin: "auto",
                  marginTop: "30px",
                }}
              >
                <Box sx={{ margin: "auto", width: "40%" }}>
                  <img
                    src={not_found}
                    alt=""
                    width={"100%"}
                    sx={{ margin: "auto" }}
                  />
                </Box>
                <Typography textTransform={"capitalize"} align="center" fontSize={"17px"} color={"crimson"}>
                  {" "}
                  No refund invoices found for selected date
                </Typography>
              </Box>
            )}
          </TableContainer>
        </Grid>
      </Grid>

      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "flex-end",
          }}
        >
          {/* <Typography>
                                    Displaying collection page  {page} {' '} out of  {' '} {totalPage},  {collectionArray?.meta?.total_count} in total count
                                </Typography> */}

          <Box gap={1} justifyContent="end" display="flex" alignItems="center" flexWrap="wrap">
            {/* Previous */}
            <Button
              onClick={handlePrevious}
              disabled={page === 1}
              startIcon={<ArrowBackIcon sx={{ fontSize: "14px !important" }} />}
              sx={{ fontSize: "12px", textTransform: "capitalize", color: page === 1 ? "grey" : "#336cfb", minWidth: "auto" }}
            >
              Prev
            </Button>

            {/* Page numbers with ellipsis */}
            {(() => {
              const pages = [];
              if (totalPage <= 7) {
                for (let i = 1; i <= totalPage; i++) pages.push(i);
              } else {
                pages.push(1);
                if (page > 3) pages.push("...");
                for (let i = Math.max(2, page - 1); i <= Math.min(totalPage - 1, page + 1); i++) pages.push(i);
                if (page < totalPage - 2) pages.push("...");
                pages.push(totalPage);
              }
              return pages.map((p, i) =>
                p === "..." ? (
                  <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", color: "#888", px: "2px", alignSelf: "center" }}>…</Typography>
                ) : (
                  <Button
                    key={p}
                    onClick={() => setPage(p)}
                    sx={{
                      fontSize: "12px",
                      minWidth: "30px",
                      height: "30px",
                      padding: "2px",
                      borderRadius: "6px",
                      color: page === p ? "#fff" : "#333",
                      backgroundColor: page === p ? "#007A99" : "#fff",
                      border: "1px solid #d0d0d0",
                      "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                    }}
                  >
                    {p}
                  </Button>
                )
              );
            })()}

            {/* Next */}
            <Button
              onClick={handleNext}
              disabled={page === totalPage}
              endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
              sx={{ fontSize: "12px", textTransform: "capitalize", color: page === totalPage ? "grey" : "#336cfb", minWidth: "auto" }}
            >
              Next
            </Button>

            {/* Jump to page */}
            <Box display="flex" alignItems="center" gap="4px" ml={1}>
              <Typography sx={{ fontSize: "12px", color: "#555", whiteSpace: "nowrap" }}>Go to</Typography>
              <TextField
                size="small"
                type="number"
                inputProps={{ min: 1, max: totalPage, style: { padding: "2px 6px", fontSize: "12px", width: "44px", textAlign: "center" } }}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", height: "30px" } }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const val = parseInt(e.target.value, 10);
                    if (val >= 1 && val <= totalPage) { setPage(val); e.target.value = ""; }
                  }
                }}
              />
            </Box>
          </Box>

          <FormControl variant="outlined" size="small" sx={{ width: "90px" }}>
            <InputLabel id="items-per-page-label">Rows</InputLabel>
            <Select
              labelId="items-per-page-label"
              label="Rows"
              value={itemPerPage}
              onChange={(e) => setItemPerPage(e.target.value)}
              sx={{ height: "30px", "&:hover": { boxShadow: "0 8px 24px rgba(0,0,0,0.12)" } }}
            >
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* <CustomModal
                customStyles={{ minWidth: "90%" }}
                open={openBillByInvoice}
                onClose={handleOpenBillByInvoiceClose}
            >
                <PastBillPharmacyReturnInvoices
                    id={selectedInvoiceId}
                    uid={selectedInvoiceUid}
                    setOpenBillByInvoice={setOpenBillByInvoice}
                    onClose={handleOpenBillByInvoiceClose}
                    refetch={refetch}
                    showBtn={selectedDate !== new Date().toISOString().split("T")[0]}
                />
            </CustomModal> */}
    </Box>
  );
};

export default RefundInvoices;
